module.exports = __webpack_public_path__ + "static/media/ploSCHadka.608d19b6.png";